<div *ngIf="busy">Why should you never fall in love with a tennis player? To them, &quot;Love&quot; means nothing.<br />Loading....</div>

<div *ngIf="!busy" class="tournament-bracket">
  <a [routerLink]="['/tournament', ladderId]">See My Brackets</a>
  <ng-container *ngFor="let tournamentBracket of tournamentBrackets">
    <h2>{{tournamentBracket.name}}</h2>
    <table style="background: #fff; width: 100%;">
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:0}}</td>
        <td class="round4"></td>
        <td class="round2"></td>
        <td class="round1"></td>
      </tr>
      <tr>
        <td class="round8"></td>
        <td class="round4 player left-bordered">{{tournamentBracket.round4|player:0}}</td>
        <td class="round2"></td>
        <td class="round1"></td>
      </tr>
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:1}}</td>
        <td class="round4 score left-bordered">{{tournamentBracket.round4|score:0}}</td>
        <td class="round2 left-bordered"></td>
        <td class="round1"></td>
      </tr>
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:2}}</td>
        <td class="round4"></td>
        <td class="round2 player left-bordered">{{tournamentBracket.round2|player:0}}</td>
        <td class="round1"></td>
      </tr>
      <tr>
        <td class="round8"></td>
        <td class="round4 player left-bordered">{{tournamentBracket.round4|player:1}}</td>
        <td class="round2 score left-bordered">{{tournamentBracket.round2|score:00}}</td>
        <td class="round1 left-bordered"></td>
      </tr>
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:3}}</td>
        <td class="round4 score left-bordered">{{tournamentBracket.round4|score:1}}</td>
        <td class="round2"></td>
        <td class="round1 left-bordered"></td>
      </tr>

      <tr class="center-row">
        <td class="round8"></td>
        <td class="round4"></td>
        <td class="round2"></td>
        <td class="round1 player left-bordered">
          <fa-icon [icon]="faTrophy"></fa-icon>
          &nbsp;
          <b>{{tournamentBracket.round1|player:0}}</b>
        </td>
      </tr>

      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:4}}</td>
        <td class="round4"></td>
        <td class="round2"></td>
        <td class="round1 score left-bordered">{{tournamentBracket.round1|score:0}}</td>
      </tr>
      <tr>
        <td class="round8"></td>
        <td class="round4 player left-bordered">{{tournamentBracket.round4|player:2}}</td>
        <td class="round2"></td>
        <td class="round1 left-bordered"></td>
      </tr>
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:5}}</td>
        <td class="round4 score left-bordered">{{tournamentBracket.round4|score:2}}</td>
        <td class="round2 left-bordered"></td>
        <td class="round1 left-bordered"></td>
      </tr>
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:6}}</td>
        <td class="round4"></td>
        <td class="round2 player left-bordered">{{tournamentBracket.round2|player:1}}</td>
        <td class="round1 left-bordered"></td>
      </tr>
      <tr>
        <td class="round8"></td>
        <td class="round4 player left-bordered">{{tournamentBracket.round4|player:3}}</td>
        <td class="round2 score left-bordered">{{tournamentBracket.round2|score:1}}</td>
        <td class="round1"></td>
      </tr>
      <tr>
        <td class="round8 player">{{tournamentBracket.round8|player:7}}</td>
        <td class="round4 score left-bordered">{{tournamentBracket.round4|score:3}}</td>
        <td class="round2"></td>
        <td class="round1"></td>
      </tr>
    </table>
    <br /><br /><br />
  </ng-container>
</div>